import { ObjectSchema } from "@hapi/joi";

import Joi, { getAttachmentsSchema } from "fe-shared/src/helpers/validation";
import { ErrorMessages, FileInterface } from "fe-shared/src/types/common";
import { COMMENT_LENGTH_LIMIT } from "consts";

type Content = { [key: string]: unknown };
export interface InvoiceAdjustmentContent extends Content {
  reasonCodes: number[];
  amount: string;
  comment: string;
  attachments: FileInterface[];
  isCommentVisibleToParticipant: boolean;
}

export const initialContent: InvoiceAdjustmentContent = {
  reasonCodes: [],
  amount: "0",
  comment: "",
  attachments: [],
  isCommentVisibleToParticipant: false,
};

export const errorMessages: ErrorMessages = {
  reasonCodes: {
    "array.min": "validation.reasonCodesRequired",
  },
  comment: {
    "string.empty": "validation.adjustmentCommentRequired",
    "string.max": "validation.adjustmentCommentIsTooLong",
  },
  amount: {
    "number.base": "validation.sumRequired",
    "any.invalid": "validation.sumZero",
    "number.min": "validation.sumInvalid",
  },
};

export const getValidationConfig = (
  originalSum: number
): ObjectSchema<InvoiceAdjustmentContent> =>
  Joi.object({
    reasonCodes: Joi.array().items(Joi.number().integer()).min(1),
    amount: Joi.number().min(-originalSum).invalid(0).required(),
    comment: Joi.string().max(COMMENT_LENGTH_LIMIT).required(),
    isCommentVisibleToParticipant: Joi.boolean(),
    attachments: getAttachmentsSchema("attachments"),
  });
